export var disconnectNativeAudioNodeFromNativeAudioNode = function disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input) {
  var inputs = nativeDestinationAudioNode.inputs;

  if (input === undefined || output === undefined) {
    nativeSourceAudioNode.disconnect(nativeDestinationAudioNode);
  } else if (inputs !== undefined) {
    nativeSourceAudioNode.disconnect(inputs[input], output, 0);
  } else {
    nativeSourceAudioNode.disconnect(nativeDestinationAudioNode, output, input);
  }
};